<!-- 富文本展示页面 -->
<template>
  <div class="iframeView">
    <div class="nav-top">
      <i class="iconfont icon-zglsfanhui" @click="toIndex()"></i>
      中国律师网
    </div>
    <div class="iframe-content" v-html="introduce"></div>
  </div>
</template>

<script>
import api from "../api/index";

export default {
  data() {
    return {
      introduce: "",
      from: "",
      type: "",
      catalogIdList:{
        rightflow:'b9a95986600746be946c1f0ab36888db',
        rightduty:'db27ca9f410c4b5db7cce7cc8be0546f',
        complainflow:'0cf13ad9abf742a0b413678dcec12675',
        complainduty:'95146dedebca46a8a791687b429520ec'
      }
    };
  },
  created() {
    if (this.$route.params) {
      this.from = this.$route.params.from;
      this.type = this.$route.params.type;
    }
    this.getCatalogInfo()
  },
  methods: {
    toIndex() {
      this.$router.push({
        name: this.from,
      });
    },
    getCatalogInfo(){
      let params = {
        catalogId : this.catalogIdList[this.type]
      }
      api.getCatalogInfo(params).then((res) => {
        if (res.data.code === 1) {
          this.introduce = res.data.result.introduce
        }else {
          this.$message.error(res.data.description)
        }
      });
    }
  },
};
</script>
<style lang='scss' scoped>
.iframeView {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f4f6fa;
  .nav-top {
    position: relative;
    width: 100%;
    height: 2.75rem;
    background: #ffffff;
    text-align: center;
    font-weight: 600;
    font-size: 1.06rem;
    color: #323233;
    line-height: 2.75rem;
    .iconfont {
      position: absolute;
      left: 1rem;
      top: 0;
      font-size: 1.25rem;
      color: #323233;
    }
  }
  .iframe-content {
    margin: 1rem 0;
    width: 100%;
    height: calc(100% - 2.75rem);
    padding: 0.63rem 1rem;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 0.75rem 0.75rem 0rem 0rem;
    overflow: auto;
  }
}

</style>